export default "__VITE_ASSET__C7JOSp54__"